export default __webpack_public_path__ + "static/media/c2.d8de668d.svg";